import { mergeObjectTypes } from '../cacheHelpers';

const NetworksLabelType = {
  merge: mergeObjectTypes
};

export default NetworksLabelType;
